// extracted by mini-css-extract-plugin
export default {"figure":"Figure_figure__gJEA6","figureEatable":"Figure_figureEatable__-9QR8"};